module.exports = __webpack_public_path__ + "gb.png?87709270d78d6e90d871da9144a6a8e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gb.png
// module id = 104
// module chunks = 0